import { themeColors } from '../../themeColors';
/**
 * @file   src\mobile\components\AdFilterPopup.js
 * @brief  This file is responsible for adFilter popup
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React, { useEffect, useState, useRef } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import Accordion from "react-bootstrap/Accordion";
import RangeSliderMobile from "../components/RangeSliderMobile";
import PropertyTypeBtns from "../components/PropertyTypeBtns";
import DateRangeSelectorMob from "../components/DateRangeSelectorMob";
import { accsPvtBthRmchkBxFilter, adaAccessibleChkBx, alwPetsChkBx, BUY, DEFAULT_MAX_BUDGET_BUY, DEFAULT_MAX_BUDGET_LTR, DEFAULT_MAX_BUDGET_STR, DEFAULT_STEP_VALUE_BUY, DEFAULT_STEP_VALUE_LTR, DEFAULT_STEP_VALUE_STR, INDEX_TO_BE_SLICE_15, LONG_RENT, pvtEntrnceChkBx, SHORT_RENT } from "../../constants/common";
import TextBox from "../../components/Common/TextBox";
import MobileDropdownSelect from "./MobileDropdownSelect";
import { thousandSeperatedValueFilter } from "../../helpers/common";
import { getPropertyTypes } from "../../services/commonServices";
import { getSquareFeetList } from "../../services/wantAdService";
import {
  convertToNumber,
  handleNegativeInput,
} from "../../helpers/validations";
import {
  replaceComma,
  replaceString,
  checkIsNumber,
  arraySplice,
  filterArrayBasedOnKey,
} from "../../helpers/common";

import { usePrevious } from "../../hooks/usePrevious";

const AdFilterPopup = (props) => {
  const {
    updateFilter,
    adType,
    clearFilterQuery,
    handleFilterApply,
    showFilterPopup,
    handleFilterPopUpClose,
    setFilterQueryForApply,
    filterQueryForApply,
    setLocation,
  } = props;

  const MIN_SF_DROPDOWN = "minSFDrop";
  const MAX_SF_DROPDOWN = "maxSFDrop";
  const [typeOfPlaceList, setTypeOfPlaceList] = useState([]);
  const [propertyList, setPropertyList] = useState([]);
  const [selectedTypeOfPlace, setSelectedTypeOfPlace] = useState([]);
  const [budgetRange, setBudgetRange] = useState("");
  const [squareFootageMinValue, setSquareFootageMinValue] = useState(null);
  const [squareFootageMaxValue, setSquareFootageMaxValue] = useState(null);
  const [propertyCount, setPropertyCount] = useState(0);
  const [tPCount, setTPCount] = useState(0);
  const [squareFeetList, setSqareFeetList] = useState([]);
  const [isPrivateRoomSelected, setIsPrivateRoomSelected] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [squareFeetMinList, setSqareFeetMinList] = useState([]);
  const [squareFeetMaxList, setSqareFeetMaxList] = useState([]);
  const minRef = useRef(null);
  const maxRef = useRef(null);
  let DEFAULT_MAX_BUDGET;
  const DEFAULT_MIN_BUDGET = 0;
  let DEFAULT_STEP_VALUE;

  if (adType === BUY) {
    DEFAULT_MAX_BUDGET = DEFAULT_MAX_BUDGET_BUY;
    DEFAULT_STEP_VALUE = DEFAULT_STEP_VALUE_BUY;
  } else if (adType === LONG_RENT) {
    DEFAULT_MAX_BUDGET = DEFAULT_MAX_BUDGET_LTR;
    DEFAULT_STEP_VALUE = DEFAULT_STEP_VALUE_LTR;
  } else {
    DEFAULT_MAX_BUDGET = DEFAULT_MAX_BUDGET_STR;
    DEFAULT_STEP_VALUE = DEFAULT_STEP_VALUE_STR;
  }

  const budgetMin =
    _.get(filterQueryForApply, "priceMin")
  const budgetMax =
    _.get(filterQueryForApply, "priceMax")
  const STR_OPTION_DETAILS_PVT_ROOM = [
    { id: adaAccessibleChkBx, text: "ADA Accessible" },
    { id: alwPetsChkBx, text: "Allows pets" },
    { id: accsPvtBthRmchkBxFilter, text: "Access to private bathroom" },
    { id: pvtEntrnceChkBx, text: "Private Entrance" },
  ];

  const STR_OPTION_DETAILS_ALL = [
    { id: adaAccessibleChkBx, text: "ADA Accessible" },
    { id: alwPetsChkBx, text: "Allows pets" },
  ];

  useEffect(() => {
    setPropertyCount(null);
    setTPCount(null);
    if (adType === BUY) {
      getPropertyTypes(adType)
        .then((response) => {
          if (response.errorCode === 0 && _.get(response, "result", null)) {
            const propertyTypes = _.get(response, "result", null);
            setPropertyList(propertyTypes);
          }
        })
        .catch((err) => {
          console.log("Error", err);
        });
    } else {
      setPropertyList([]);
    }

    let DEFAULT_BUDGET_RANGE = [DEFAULT_MIN_BUDGET, DEFAULT_MAX_BUDGET];
    if (budgetMin && !budgetMax) {
      DEFAULT_BUDGET_RANGE = [budgetMin, DEFAULT_MAX_BUDGET];
    } else if (!budgetMin && budgetMax) {
      DEFAULT_BUDGET_RANGE = [DEFAULT_MIN_BUDGET, budgetMax];
    } else if (budgetMin && budgetMax) {
      DEFAULT_BUDGET_RANGE = [budgetMin, budgetMax];
    }
    setBudgetRange(DEFAULT_BUDGET_RANGE);
    setSelectedTypeOfPlace([10, 11, 6]);
    getSquareFeetList()
      .then((response) => {
        if (response.errorCode === 0 && _.get(response, "result", null)) {
          const list = _.get(response, "result", null);
          let newList = [];
          list.map((lst) => {
            const value = _.get(lst, "Sqft_Value");
            const text = _.get(lst, "Sqft_Value_Text", "");
            newList.push({ value: value, label: text });
          });
          setPropertyCount(0);
          setSqareFeetMinList([{ value: null, label: "No min" }, ...newList]);
          setSqareFeetMaxList([{ value: null, label: "No max" }, ...newList]);
          setSquareFootageMaxValue({ value: null, label: "No max" });
          setSquareFootageMinValue({ value: null, label: "No min" });
          setStartDate(null);
          setEndDate(null);
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  }, [adType]);

  useEffect(() => {
    if (adType !== BUY) {
      let type = "";
      if (
        selectedTypeOfPlace.includes(11) &&
        selectedTypeOfPlace.includes(10)
      ) {
        type = "es-pr";
      } else if (
        selectedTypeOfPlace.includes(11) &&
        selectedTypeOfPlace.includes(6)
      ) {
        type = "pr-land";
      } else if (
        selectedTypeOfPlace.includes(10) &&
        selectedTypeOfPlace.includes(6)
      ) {
        type = "es-land";
      }
      if (
        selectedTypeOfPlace.includes(11) &&
        selectedTypeOfPlace.includes(10) &&
        selectedTypeOfPlace.includes(6)
      ) {
        type = "all";
      }
      if (selectedTypeOfPlace.length == 1 && selectedTypeOfPlace.includes(11)) {
        type = "privateroom";
      }
      if (selectedTypeOfPlace.length == 1 && selectedTypeOfPlace.includes(10)) {
        type = "entirespace";
      }
      if (selectedTypeOfPlace.length == 1 && selectedTypeOfPlace.includes(6)) {
        type = "land";
      } else {
        setPropertyList([]);
      }
      getPropertyTypes(type)
        .then((response) => {
          if (response.errorCode === 0 && _.get(response, "result", null)) {
            const propertyTypes = _.get(response, "result", null);
            setPropertyList(propertyTypes);
          }
        })
        .catch((err) => {
          console.log("Error", err);
        });

      if (selectedTypeOfPlace.includes(11)) {
        setIsPrivateRoomSelected(true);
      } else {
        setIsPrivateRoomSelected(false);
      }
    }
  }, [selectedTypeOfPlace]);

  const prevMinBdgt = usePrevious(budgetRange[0]);
  const prevMaxBdgt = usePrevious(budgetRange[1]);

  useEffect(() => {
    updateRangeSliders();
  }, [startDate, endDate]);

  useEffect(() => {
    if (prevMinBdgt && prevMinBdgt !== budgetRange[0]) {
      setFilterQueryForApply((prevState) => ({
        ...prevState,
        priceMin: budgetRange[0],
      }));
    }
  }, [budgetRange[0]]);

  useEffect(() => {
    const mxBdgt = budgetRange[1] === DEFAULT_MAX_BUDGET ? "" : budgetRange[1];
    if (prevMaxBdgt && prevMaxBdgt !== budgetRange[1]) {
      setFilterQueryForApply((prevState) => ({
        ...prevState,
        priceMin: budgetMin,
        priceMax: mxBdgt,
      }));
    }
  }, [budgetRange[1]]);

  useEffect(() => {
    if (adType !== BUY) {
      ///      For loading type of place
      getPropertyTypes("rent")
        .then((response) => {
          if (response.errorCode === 0 && _.get(response, "result", null)) {
            const propertyTypes = _.get(response, "result", null);
            setTypeOfPlaceList(propertyTypes);
          }
        })
        .catch((err) => {
          console.log("Error", err);
        });
    }
  }, [adType]);

  /**
   * To handle property type selection
   * @param {*} value
   */

  const handlePropertyClick = (value) => {
    const selectedItemArray = getSelectedItems("propertyType");

    if (value) {
      let itemArray;
      if (_.includes(selectedItemArray, value)) {
        itemArray = selectedItemArray.filter((e) => e !== value);
      } else {
        itemArray = [...selectedItemArray, value];
      }
      setFilterQueryForApply((prevState) => ({
        ...prevState,
        propertyType: itemArray,
      }));
      setPropertyCount(itemArray.length);
    }
  };
  /**
   * To handle type of place click
   * @param {*} value
   */
  const handleTypeOfPlaceClick = (value) => {
    const selectedItemArray = getSelectedItems("typeOfPlace");
    if (value) {
      let itemArray;
      if (_.includes(selectedItemArray, value)) {
        itemArray = selectedItemArray.filter((e) => e !== value);
      } else {
        itemArray = [...selectedItemArray, value];
      }
      setSelectedTypeOfPlace(itemArray);
      if (itemArray.includes(11)) {
        setIsPrivateRoomSelected(true);
      } else {
        setIsPrivateRoomSelected(false);
      }

      setFilterQueryForApply((prevState) => ({
        ...prevState,
        typeOfPlace: itemArray,
      }));
      setTPCount(itemArray.length);
    }
  };
  /**
   * To handle clear filter
   */
  const clearFilter = () => {
    clearFilterQuery();
    setSquareFootageMinValue({ value: null, label: "No min" });
    setSquareFootageMaxValue({ value: null, label: "No max" });
    setBudgetRange([DEFAULT_MIN_BUDGET, DEFAULT_MAX_BUDGET]);
    setPropertyCount(0);
    setTPCount(0);
    setLocation("");
    handleFilterPopUpClose();
  };

  const getSelectedItems = (property) => {
    const selectedItemArray = _.get(filterQueryForApply, property, []);
    return selectedItemArray;
  };

  const updateRangeSliders = async () => {
    setFilterQueryForApply((prevState) => ({
      ...prevState,
      fromDate: startDate,
      toDate: endDate,
    }));
  };
  /**
   * To handle additional requirements values selection
   * @returns
   */
  const handleAdditionalRequirementsClick = (e, typeId) => {
    const selectedItemArray = getSelectedItems(e.target.value);
    if (selectedItemArray == 0 || selectedItemArray == null) {
      setFilterQueryForApply((prevState) => ({
        ...prevState,
        [typeId]: 1,
      }));
      setFilterQueryForApply((prevState) => ({
        ...prevState,
        [typeId]: 1,
      }));
    } else {
      setFilterQueryForApply((prevState) => ({
        ...prevState,
        [typeId]: 0,
      }));
    }
  };
  /**
   * To load additional requirements
   * @returns
   */
  const loadAdditionalRequirements = () => {
    const options = isPrivateRoomSelected
      ? STR_OPTION_DETAILS_PVT_ROOM
      : STR_OPTION_DETAILS_ALL;

    const List =
      options &&
      options.map((pt) => {
        const typeId = _.get(pt, "id", "");
        const typeText = _.get(pt, "text", "");
        const isChecked = getSelectedItems(typeId);
        return (
          <div className="checkbox-wrap mb-3">
            <label
              key={typeId}
              className="form-check-label checkbox-label"
              for={typeId}
            >
              <input
                className="form-check-input"
                type="checkbox"
                name="chkType"
                value={typeId ? typeId : ""}
                id={typeId}
                checked={isChecked == 1 ? true : false}
                onChange={(e) => handleAdditionalRequirementsClick(e, typeId)}
              />
              {typeText}
            </label>
          </div>
        );
      });

    return List;
  };

  /**
   * To handle number of budget min changes
   * @returns
   */
  const handleBudgetMinChange = (e) => {
    const budgetMax = budgetRange && budgetRange[1];
    const value = handleNegativeInput(e.target.value);
    if (value) {
      setBudgetRange([parseInt(replaceComma(value)), budgetMax]);
    } else {
      setBudgetRange([null, budgetMax]);
    }
  };

  const handleBudgetMaxChange = (e) => {
    const budgetMin = budgetRange && budgetRange[0];
    const value = handleNegativeInput(e.target.value);
    if (parseInt(replaceComma(value))) {
      setBudgetRange([budgetMin, parseInt(replaceComma(value))]);
    } else {
      setBudgetRange([budgetMin, null]);
    }
  };

  const handleSquareFootMinChange = (e) => {
    const value = _.get(e, "value", "");
    setSquareFootageMinValue(e);
    setFilterQueryForApply((prevState) => ({
      ...prevState,
      sqrftMin: value,
    }));
  };

  const handleSquareFootMaxChange = (e) => {
    const value = _.get(e, "value", "");
    setSquareFootageMaxValue(e);
    setFilterQueryForApply((prevState) => ({
      ...prevState,
      sqrftMax: value,
    }));
  };
  /**
   * To handle number of bedroom selection
   * @returns
   */
  const handleBedRoomClick = (value) => {
    const noOfBedrooms = getSelectedItems("bedrooms");
    const selectedValue = replaceString(value, "+");
    if (selectedValue == noOfBedrooms) {
      setFilterQueryForApply((prevState) => ({
        ...prevState,
        bedrooms: null,
      }));
    } else {
      setFilterQueryForApply((prevState) => ({
        ...prevState,
        bedrooms: selectedValue,
      }));
    }
  };
  /**
   * To handle number of beds selection
   * @returns
   */
  const handleBedsClick = (value) => {
    const noOfBeds = getSelectedItems("beds");

    const selectedValue = replaceString(value, "+");
    if (selectedValue == noOfBeds) {
      setFilterQueryForApply((prevState) => ({
        ...prevState,
        beds: null,
      }));
    } else {
      setFilterQueryForApply((prevState) => ({
        ...prevState,
        beds: selectedValue,
      }));
    }
  };
  /**
   * To handle number of bathrooms selection
   * @returns
   */
  const handleBathRoomClick = (value) => {
    const noOfBathrooms = getSelectedItems("baths");

    const selectedValue = replaceString(value, "+");
    if (selectedValue == noOfBathrooms) {
      setFilterQueryForApply((prevState) => ({
        ...prevState,
        baths: null,
      }));
    } else {
      setFilterQueryForApply((prevState) => ({
        ...prevState,
        baths: selectedValue,
      }));
    }
  };

  const addNewOptionsToMinList = (list, newOption) => {
    const customList = buildCustomList(list, newOption);
    setSqareFeetMinList(customList);
  };

  const addNewOptionsToMaxList = (list, newOption) => {
    const customList = buildCustomList(list, newOption);
    setSqareFeetMaxList(customList);
  };

  const buildCustomList = (list, newOption) => {
    const filteredArray = filterArrayBasedOnKey({
      list: list,
      filterKey: "value",
      value: _.get(newOption, "value", null),
    });
    let customOptions = [...list];
    if (filteredArray?.length === 0 && _.get(newOption, "value", null)) {
      customOptions = [...list, newOption];
    }
    return customOptions;
  };

  const handleOnInputChange = (e, dropSection) => {
    if (dropSection === "minSFDrop") {
      if (minRef.current && minRef.current.contains(document.activeElement)) {
        if (checkIsNumber(e)) {
          const options = { value: convertToNumber(e), label: e };
          addNewOptionsToMinList(
            arraySplice(squareFeetMinList, INDEX_TO_BE_SLICE_15),
            options
          );
          setSquareFootageMinValue(options);
          setFilterQueryForApply((prevState) => ({
            ...prevState,
            sqrftMin: e,
          }));
        }
      }
    } else {
      if (maxRef.current && maxRef.current.contains(document.activeElement)) {
        if (checkIsNumber(e)) {
          const options = { value: convertToNumber(e), label: e };
          addNewOptionsToMaxList(
            arraySplice(squareFeetMaxList, INDEX_TO_BE_SLICE_15),
            options
          );
          setSquareFootageMaxValue(options);
          setFilterQueryForApply((prevState) => ({
            ...prevState,
            sqrftMax: e,
          }));
        }
      }
    }
  };
  /**
   * To handle number of bedrooms selection component
   * @returns
   */
  const loadBedRooms = () => {
    const items = ["1+", "2+", "3+", "4+", "5+"];
    const noOfBedrooms = getSelectedItems("bedrooms");
    const list =
      items &&
      items.map((itm, index) => {
        const itmValue = replaceString(itm, "+");
        return (
          <button
            type="button"
            value={itmValue}
            className={
              noOfBedrooms === itmValue
                ? "btn btn-primary active"
                : "btn btn-primary"
            }
            key={index}
            onClick={(e) => handleBedRoomClick(itmValue)}
          >
            {itm}
          </button>
        );
      });
    return list;
  };
  /**
   * To handle number of beds selection component
   * @returns
   */
  const loadBeds = () => {
    const items = ["1+", "2+", "3+", "4+", "5+"];
    const noOfBedrooms = getSelectedItems("beds");
    const list =
      items &&
      items.map((itm, index) => {
        const itmValue = replaceString(itm, "+");
        return (
          <button
            type="button"
            value={itmValue}
            className={
              noOfBedrooms === itmValue
                ? "btn btn-primary active"
                : "btn btn-primary"
            }
            key={index}
            onClick={(e) => handleBedsClick(itmValue)}
          >
            {itm}
          </button>
        );
      });
    return list;
  };
  /**
   * To handle number of bathrooms selection component
   * @returns
   */
  const loadBathRooms = () => {
    const items = ["1+", "2+", "3+", "4+", "5+"];
    const noOfBathrooms = getSelectedItems("baths");
    const list =
      items &&
      items.map((itm, index) => {
        const itmValue = replaceString(itm, "+");
        return (
          <button
            type="button"
            value={itmValue}
            className={
              noOfBathrooms === itmValue
                ? "btn btn-primary active"
                : "btn btn-primary"
            }
            key={index}
            onClick={(e) => handleBathRoomClick(itmValue)}
          >
            {itm}
          </button>
        );
      });
    return list;
  };

  return (
    <Offcanvas
      className="mobile-offcanvas zIndexPopup offcanvas-filter-height-fix offcanvas-filter-share-fix"
      show={showFilterPopup}
      onHide={handleFilterPopUpClose}
      placement="bottom"
      backdrop="static"
      {...props}
    >
      <Offcanvas.Header className="filter-offcanvas-header">
        <div className="offcanvas-sharead-wrap w-100 pe-3 ps-3">
          <div className="share-yourad-topsec w-100 pt-32 mb-20">
            <div>
              <a
                className="back-link-btn"
                href={void 0}
                role="button"
                onClick={() => handleFilterPopUpClose()}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.1003 5.39966C10.3932 5.69256 10.3932 6.16743 10.1003 6.46032L5.31066 11.25H20.5C20.9142 11.25 21.25 11.5858 21.25 12C21.25 12.4142 20.9142 12.75 20.5 12.75H5.31066L10.1003 17.5397C10.3932 17.8326 10.3932 18.3074 10.1003 18.6003C9.80744 18.8932 9.33256 18.8932 9.03967 18.6003L2.96967 12.5303C2.82902 12.3897 2.75 12.1989 2.75 12C2.75 11.8011 2.82902 11.6103 2.96967 11.4697L9.03967 5.39966C9.33256 5.10677 9.80744 5.10677 10.1003 5.39966Z"
                    fill={themeColors.neutral890}
                  />
                </svg>
              </a>
            </div>
            <div className="share-yourad-heading">Filters</div>
            <div></div>
          </div>
        </div>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="overflowXhide accordianStyle pe-3 ps-3">
          <div className="overflowXhide accordianStyle">
            <Accordion>
              {adType !== BUY && (
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    Type of place{" "}
                    {tPCount && tPCount !== 0 ? `(${tPCount})` : ""}
                  </Accordion.Header>
                  <Accordion.Body>
                    <PropertyTypeBtns
                      list={typeOfPlaceList}
                      updateFilter={updateFilter}
                      filterQuery={filterQueryForApply}
                      section="typeOfPlace"
                      onClick={handleTypeOfPlaceClick}
                    />
                  </Accordion.Body>
                </Accordion.Item>
              )}

              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  Property Type{" "}
                  {propertyCount && propertyCount !== 0
                    ? `(${propertyCount})`
                    : ""}
                </Accordion.Header>
                <Accordion.Body>
                  <PropertyTypeBtns
                    list={propertyList}
                    updateFilter={updateFilter}
                    filterQuery={filterQueryForApply}
                    section="propertyType"
                    onClick={handlePropertyClick}
                  />
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  Price
                  {adType === LONG_RENT
                    ? "(monthly)"
                    : adType === SHORT_RENT
                      ? "(nightly)"
                      : ""}
                </Accordion.Header>
                <Accordion.Body>
                  <div className="mt-2 mb-2">
                    <RangeSliderMobile
                      min={DEFAULT_MIN_BUDGET}
                      max={DEFAULT_MAX_BUDGET}
                      defaultValue={budgetRange}
                      value={
                        budgetRange && [
                          budgetRange[0] == null
                            ? DEFAULT_MIN_BUDGET
                            : budgetRange[0],
                          budgetRange[1] == null
                            ? DEFAULT_MAX_BUDGET
                            : budgetRange[1],
                        ]
                      }
                      stepValue={DEFAULT_STEP_VALUE}
                      onInput={setBudgetRange}
                    />
                  </div>

                  <div className="d-flex justify-content-between pt-4 pb-2">
                    <div className="position-relative">
                      <span className="dollar-sign-icon-mob">$</span>
                      <TextBox
                        type="text"
                        className=" pt-2 pb-2 pad-left-25"
                        value={
                          budgetRange && budgetRange[0] === ""
                            ? ""
                            : thousandSeperatedValueFilter(budgetRange[0])
                        }
                        placeholder="0"
                        onChange={(e) => {
                          handleBudgetMinChange(e);
                        }}
                      ></TextBox>
                    </div>
                    <div className="ps-2 pe-2 pt-2">-</div>
                    <div className="position-relative">
                      <span className="dollar-sign-icon-mob">$</span>
                      <TextBox
                        type="text"
                        className="pt-2 pb-2 pad-left-25"
                        value={
                          budgetRange && budgetRange[1] === DEFAULT_MAX_BUDGET
                            ? "No max"
                            : thousandSeperatedValueFilter(budgetRange[1])
                        }
                        placeholder="No max"
                        onChange={(e) => {
                          handleBudgetMaxChange(e);
                        }}
                      ></TextBox>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              {adType === SHORT_RENT && (
                <Accordion.Item eventKey="3">
                  <Accordion.Header>Dates</Accordion.Header>
                  <Accordion.Body>
                    <DateRangeSelectorMob
                      startDate={startDate}
                      setStartDate={setStartDate}
                      endDate={endDate}
                      setEndDate={setEndDate}
                    />
                  </Accordion.Body>
                </Accordion.Item>
              )}

              <Accordion.Item eventKey="4">
                <Accordion.Header>
                  {adType === SHORT_RENT ? "Rooms & beds" : "Beds and baths"}
                </Accordion.Header>
                <Accordion.Body>
                  <div className="lp-btn-group-wrap mt-2 mb-2">
                    <h6>
                      {adType === BUY || adType === LONG_RENT
                        ? "Beds"
                        : "BedRooms"}
                    </h6>

                    <div
                      className="btn-group marginBtn mb-3"
                      role="group"
                      aria-label="Basic example"
                    >
                      {loadBedRooms()}
                    </div>
                    {adType === SHORT_RENT && (
                      <>
                        <h6>Beds</h6>

                        <div
                          className="btn-group marginBtn mb-3"
                          role="group"
                          aria-label="Basic example"
                        >
                          {loadBeds()}
                        </div>
                      </>
                    )}

                    <h6>Baths</h6>

                    <div
                      className="btn-group marginBtn mb-3"
                      role="group"
                      aria-label="Basic example"
                    >
                      {loadBathRooms()}
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="5">
                <Accordion.Header>Square Footage</Accordion.Header>
                <Accordion.Body>
                  <div className="d-flex justify-content-between pt-0 pb-2">
                    <div className="w-100 test" ref={minRef}>
                      <MobileDropdownSelect
                        hideMenuPortal={true}
                        id={MIN_SF_DROPDOWN}
                        name="colors3"
                        options={squareFeetMinList}
                        className="mobile-select"
                        classNamePrefix="select"
                        placeholder="No min"
                        value={squareFootageMinValue}
                        menuPlacement="top"
                        onInputChange={(e) =>
                          handleOnInputChange(e, MIN_SF_DROPDOWN)
                        }
                        onChange={(e) => handleSquareFootMinChange(e)}
                        components={{
                          DropdownIndicator: () => null,
                          IndicatorSeparator: () => null,
                        }}
                        styles={{
                          dropdownIndicator: (provided, state) => ({
                            ...provided,
                            transform:
                              state.selectProps.menuIsOpen && "rotate(180deg)",
                          }),
                        }}
                        errorClass="error-msg error-msg-height"
                      />
                    </div>
                    <div className="pt-2 text-center pe-3 ps-3">-</div>
                    <div className="w-100" ref={props.maxRef}>
                      <MobileDropdownSelect
                        hideMenuPortal={true}
                        id={MAX_SF_DROPDOWN}
                        name="colors5"
                        options={squareFeetMaxList}
                        className="mobile-select"
                        classNamePrefix="select"
                        placeholder="No max"
                        value={squareFootageMaxValue}
                        menuPlacement="top"
                        onInputChange={(e) =>
                          handleOnInputChange(e, MAX_SF_DROPDOWN)
                        }
                        onChange={(e) => handleSquareFootMaxChange(e)}
                        components={{
                          DropdownIndicator: () => null,
                          IndicatorSeparator: () => null,
                        }}
                        styles={{
                          dropdownIndicator: (provided, state) => ({
                            ...provided,
                            transform:
                              state.selectProps.menuIsOpen && "rotate(180deg)",
                          }),
                        }}
                        errorClass="error-msg error-msg-height"
                      />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              {adType === SHORT_RENT && (
                <Accordion.Item eventKey="6">
                  <Accordion.Header>Additional requirements</Accordion.Header>
                  <Accordion.Body>
                    {loadAdditionalRequirements()}
                  </Accordion.Body>
                </Accordion.Item>
              )}
            </Accordion>

            <div className="inner-btm-fixed-nav filter-btm-fixed-btnswrap">
              <div className="btn-wrap text-center pt-0">
                <button
                  type="button"
                  className="btn btn-primary w-100 mb-20"
                  onClick={() => handleFilterApply()}
                >
                  Apply
                </button>
                <a
                  href={void 0}
                  role="button"
                  className="blue-text-link noIcn pe-0 pt-0 pb-32 d-block"
                  onClick={() => clearFilter()}
                >
                  Clear all
                </a>
              </div>
            </div>
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};
export default AdFilterPopup;
